var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmpty1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 775,
    height: 475,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty_1_svg__clip0_10367_212356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.612 367.294H43.051v101.422h543.561V367.294z",
    fill: "#F2F2F2",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.635 400.526H316.286V286.729s62.959-61.917 145.525 0c78.084 58.556 130.824 0 130.824 0v113.797z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.951 398.025v74.157",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.75 442.329h-18.859c-4.84 0-8.764 3.925-8.764 8.768v7.097c0 4.842 3.924 8.768 8.764 8.768h18.859c4.84 0 8.764-3.926 8.764-8.768v-7.097c0-4.843-3.924-8.768-8.764-8.768zM372.841 131.539c11.713 0 21.208-9.501 21.208-21.22 0-11.72-9.495-21.22-21.208-21.22s-21.208 9.5-21.208 21.22c0 11.719 9.495 21.22 21.208 21.22z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.172 225.449c10.119 0 18.322-8.207 18.322-18.332 0-10.124-8.203-18.332-18.322-18.332s-18.322 8.208-18.322 18.332c0 10.125 8.203 18.332 18.322 18.332z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.198 465.793l-73.031-73.071h-37.392l-73.03 73.071h47.937s14.022-32.215 43.789-32.215c29.768 0 43.789 32.215 43.789 32.215h47.938z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.139 399.363H306.61v8.769h284.529v-8.769z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.435 309.147l-3.202-8.476.111-53.827s-.111-14.93 24.878-14.93c24.988 0 45.816 55.534 20.828 55.534 9.021 19.478 6.246 37.564 6.246 37.564l-48.861-15.865z",
    fill: "#FFCBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.435 309.147l-3.202-8.476.111-53.827s-.111-14.93 24.878-14.93c24.988 0 45.816 55.534 20.828 55.534 9.021 19.478 6.246 37.564 6.246 37.564l-48.861-15.865z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.687 278.446c-15.454-15.97-6.059-23.266 0-23.266-1.917-11.107 5.369-23.266 13.093-22.891-31.322-10.096-66.02 35.044-28.547 68.394 0-10.745 15.617-8.693 15.454-22.237z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.687 278.446c-15.454-15.97-6.059-23.266 0-23.266-1.917-11.107 5.369-23.266 13.093-22.891-31.322-10.096-66.02 35.044-28.547 68.394 0-10.745 15.617-8.693 15.454-22.237z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.55 183.647s-40.424 57.989-42.341 61.116c-1.916 3.128 6.246 9.722 9.021 7.64 4.861-4.167 52.758-49.313 52.758-49.313",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.55 183.647s-40.424 57.989-42.341 61.116c-1.916 3.128 6.246 9.722 9.021 7.64 4.861-4.167 52.758-49.313 52.758-49.313",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.079 182.256s-30.083 42.381-34.365 48.115c-6.591 8.839 10.761 22.728 17.778 16.806 4.674-3.945 44.35-39.224 44.35-39.224",
    fill: "#F34C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.079 182.256s-30.083 42.381-34.365 48.115c-6.591 8.839 10.761 22.728 17.778 16.806 4.674-3.945 44.35-39.224 44.35-39.224",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.889 399.047H308.971c13.73-101.129 80.369-114.346 115.202-87.684v-23.886s71.716 27.434 71.716 78.133v33.437z",
    fill: "#6EC6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.889 399.047H308.971c13.73-101.129 80.369-114.346 115.202-87.684v-23.886s71.716 27.434 71.716 78.133v33.437z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.747 399.047V224.625c-22.482 0-46.775-7.64-46.775-30.561 0-23.617 15.272-39.587 37.83-31.602 35.236 17.099 74.784 154.53 74.784 154.53s4.358 15.199 4.358 25.353c0 40.978-38.876 56.702-38.876 56.702h-31.321z",
    fill: "#FFCBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.747 399.047V224.625c-22.482 0-46.775-7.64-46.775-30.561 0-23.617 15.272-39.587 37.83-31.602 35.236 17.099 74.784 154.53 74.784 154.53s4.358 15.199 4.358 25.353c0 40.978-38.876 56.702-38.876 56.702h-31.321z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.59 332.559h70.332a11.96 11.96 0 0011.825-9.353",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.951 332.559v66.489h11.796v-75.824a12.17 12.17 0 01-11.796 9.335z",
    fill: "#F34C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.951 332.559v66.489h11.796v-75.824a12.17 12.17 0 01-11.796 9.335z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.34 148.824l-40.115-45.8-41.914 62.911s-12.497 12.503 1.04 26.042c13.537 13.539 28.827 3.402 32.981-.205 4.154-3.606 48.008-42.948 48.008-42.948z",
    fill: "#F34C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.34 148.824l-40.115-45.8-41.914 62.911s-12.497 12.503 1.04 26.042c13.537 13.539 28.827 3.402 32.981-.205 4.154-3.606 48.008-42.948 48.008-42.948z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.169 154.828c16.87 0 30.545-13.683 30.545-30.561 0-16.879-13.675-30.561-30.545-30.561-16.869 0-30.544 13.682-30.544 30.561 0 16.878 13.675 30.561 30.544 30.561z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.169 154.828c16.87 0 30.545-13.683 30.545-30.561 0-16.879-13.675-30.561-30.545-30.561-16.869 0-30.544 13.682-30.544 30.561 0 16.878 13.675 30.561 30.544 30.561z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.187 93.706a30.407 30.407 0 00-19.415 6.968 30.57 30.57 0 00-6.911 20.894 30.569 30.569 0 008.911 20.123 30.532 30.532 0 0040.995 1.995 30.563 30.563 0 004.043-32.468 30.543 30.543 0 00-27.623-17.512z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.482 145.779c11.761-13.691 20.373-23.669 20.992-24.295 3.471-3.472 4.207 5.022 4.207 5.022a7.798 7.798 0 01-2.282 5.508 7.776 7.776 0 01-5.506 2.278 9.713 9.713 0 01-6.88-2.849 9.728 9.728 0 01-2.848-6.884c0-3.228 1.282-6.323 3.563-8.606a12.162 12.162 0 018.601-3.565c4.029 0 7.893 1.602 10.741 4.452a15.202 15.202 0 014.45 10.747 19.028 19.028 0 01-5.565 13.448 18.996 18.996 0 01-13.441 5.568 23.751 23.751 0 01-21.949-14.672 23.777 23.777 0 01-1.806-9.096 29.718 29.718 0 018.698-21.011 29.689 29.689 0 0120.999-8.703 37.105 37.105 0 0126.254 10.883 37.168 37.168 0 018.047 12.054 37.17 37.17 0 012.822 14.218 46.448 46.448 0 01-13.591 32.828 46.384 46.384 0 01-32.81 13.598 57.994 57.994 0 01-41.011-17.002 58.026 58.026 0 01-16.981-41.039 72.56 72.56 0 0121.234-51.293 72.48 72.48 0 0151.265-21.246h205.813a34.687 34.687 0 0124.542 10.172 34.738 34.738 0 0110.162 24.557v2.432a34.74 34.74 0 01-10.164 24.553 34.692 34.692 0 01-24.54 10.17h-22.511a34.7 34.7 0 00-24.54 10.174 34.739 34.739 0 00-10.164 24.555v273.191",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.889 92.665c25.494 0 46.161-20.678 46.161-46.186S665.383.292 639.889.292s-46.161 20.679-46.161 46.187 20.667 46.186 46.161 46.186z",
    fill: "#6EC6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.889 92.665c25.494 0 46.161-20.678 46.161-46.186S665.383.292 639.889.292s-46.161 20.679-46.161 46.187 20.667 46.186 46.161 46.186z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.93 430.667s-1.577-28.159 20.332-46.964c-25.064 5.103-33.986 44.795-33.986 44.795l13.654 2.169z",
    fill: "#88F4CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.93 430.667s-1.577-28.159 20.332-46.964c-25.064 5.103-33.986 44.795-33.986 44.795l13.654 2.169z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.281 426.838s3.097-20.109-17.562-32.286c24.538 2.257 31.193 30 31.193 30l-13.631 2.286z",
    fill: "#88F4CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.281 426.838s3.097-20.109-17.562-32.286c24.538 2.257 31.193 30 31.193 30l-13.631 2.286z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.502 466.962h-34.4l-8.46-43.445h51.32l-8.46 43.445z",
    fill: "#DDF8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.502 466.962h-34.4l-8.46-43.445h51.32l-8.46 43.445z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.05 190.767a11.693 11.693 0 00-11.685-11.691H12.477a11.68 11.68 0 00-8.263 3.424 11.695 11.695 0 00-3.422 8.267v107.56H325.05v-107.56z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.05 190.767a11.693 11.693 0 00-11.685-11.691H12.477a11.68 11.68 0 00-8.263 3.424 11.695 11.695 0 00-3.422 8.267v107.56H325.05v-107.56z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.792 298.327v107.56a11.684 11.684 0 0011.685 11.691h300.888a11.693 11.693 0 0011.685-11.691v-107.56H.792z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.792 298.327v107.56a11.684 11.684 0 0011.685 11.691h300.888a11.693 11.693 0 0011.685-11.691v-107.56H.792z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.286 199.535c0-3.1-1.231-6.074-3.423-8.267a11.682 11.682 0 00-8.262-3.424H21.241a11.684 11.684 0 00-11.685 11.691v98.792h306.73v-98.792z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.286 199.535c0-3.1-1.231-6.074-3.423-8.267a11.682 11.682 0 00-8.262-3.424H21.241a11.684 11.684 0 00-11.685 11.691v98.792h306.73v-98.792z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.556 298.327v98.791A11.693 11.693 0 0021.24 408.81H304.6a11.69 11.69 0 0011.685-11.692v-98.791H9.556z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.556 298.327v98.791A11.693 11.693 0 0021.24 408.81H304.6a11.69 11.69 0 0011.685-11.692v-98.791H9.556z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.601 187.844H21.241a11.684 11.684 0 00-11.685 11.691v8.184h306.73v-8.184c0-3.1-1.231-6.074-3.423-8.267a11.682 11.682 0 00-8.262-3.424z",
    fill: "#6EC6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.601 187.844H21.241a11.684 11.684 0 00-11.685 11.691v8.184h306.73v-8.184c0-3.1-1.231-6.074-3.423-8.267a11.682 11.682 0 00-8.262-3.424z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.915 201.874a4.09 4.09 0 004.09-4.092 4.09 4.09 0 10-4.09 4.092z",
    fill: "#F34C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.915 201.874a4.09 4.09 0 004.09-4.092 4.09 4.09 0 10-4.09 4.092z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.981 201.874a4.09 4.09 0 004.09-4.092 4.09 4.09 0 10-4.09 4.092z",
    fill: "#FCBF4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.981 201.874a4.09 4.09 0 004.09-4.092 4.09 4.09 0 10-4.09 4.092z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.049 201.874a4.09 4.09 0 004.09-4.092 4.09 4.09 0 10-8.18 0 4.09 4.09 0 004.09 4.092z",
    fill: "#88F4CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.049 201.874a4.09 4.09 0 004.09-4.092 4.09 4.09 0 10-8.18 0 4.09 4.09 0 004.09 4.092z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.105 258.869h-53.75a2.338 2.338 0 000 4.676h53.75a2.338 2.338 0 000-4.676z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.105 258.869h-53.75a2.338 2.338 0 000 4.676h53.75a2.338 2.338 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.397 270.268h-53.75a2.338 2.338 0 000 4.676h53.75a2.338 2.338 0 000-4.676z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.397 270.268h-53.75a2.338 2.338 0 000 4.676h53.75a2.338 2.338 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.105 322.002h-53.75a2.338 2.338 0 000 4.676h53.75a2.338 2.338 0 000-4.676z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.105 322.002h-53.75a2.338 2.338 0 000 4.676h53.75a2.338 2.338 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.454 333.401H24.647a2.338 2.338 0 000 4.676h36.807a2.338 2.338 0 000-4.676z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.454 333.401H24.647a2.338 2.338 0 000 4.676h36.807a2.338 2.338 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.873 333.401h-53.751a2.337 2.337 0 000 4.676h53.751a2.337 2.337 0 000-4.676z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.873 333.401h-53.751a2.337 2.337 0 000 4.676h53.751a2.337 2.337 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.165 322.002h-53.751a2.337 2.337 0 000 4.676h53.751a2.337 2.337 0 000-4.676z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.165 322.002h-53.751a2.337 2.337 0 000 4.676h53.751a2.337 2.337 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.873 258.869h-53.751a2.337 2.337 0 000 4.676h53.751a2.337 2.337 0 000-4.676z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.873 258.869h-53.751a2.337 2.337 0 000 4.676h53.751a2.337 2.337 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.222 270.268h-36.808a2.337 2.337 0 000 4.676h36.808a2.338 2.338 0 000-4.676z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.222 270.268h-36.808a2.337 2.337 0 000 4.676h36.808a2.338 2.338 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.088 236.655H109.755c-8.067 0-14.607 6.543-14.607 14.614V357.66c0 8.071 6.54 14.614 14.607 14.614h106.333c8.067 0 14.606-6.543 14.606-14.614V251.269c0-8.071-6.539-14.614-14.606-14.614z",
    fill: "#6EC6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.088 236.655H109.755c-8.067 0-14.607 6.543-14.607 14.614V357.66c0 8.071 6.54 14.614 14.607 14.614h106.333c8.067 0 14.606-6.543 14.606-14.614V251.269c0-8.071-6.539-14.614-14.606-14.614z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.479 302.127c-1.063-1.672-3.47-3.689-6.088-5.074a15.201 15.201 0 004.864-16.903 15.19 15.19 0 00-23.127-7.374 15.197 15.197 0 00-5.808 16.601 15.201 15.201 0 005.124 7.676c-2.617 1.385-5.025 3.402-6.088 5.074-1.811 2.846-7.887 13.018-7.887 33.32h46.897c0-20.302-6.076-30.474-7.887-33.32z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.479 302.127c-1.063-1.672-3.47-3.689-6.088-5.074a15.201 15.201 0 004.864-16.903 15.19 15.19 0 00-23.127-7.374 15.197 15.197 0 00-5.808 16.601 15.201 15.201 0 005.124 7.676c-2.617 1.385-5.025 3.402-6.088 5.074-1.811 2.846-7.887 13.018-7.887 33.32h46.897c0-20.302-6.076-30.474-7.887-33.32z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.853 474.076l-135.89-135.958a54.779 54.779 0 00-7.512-75.498 54.708 54.708 0 00-75.698 4.489 54.77 54.77 0 00-14.533 38.221 54.768 54.768 0 0015.987 37.636 54.71 54.71 0 0037.588 16.059 54.708 54.708 0 0038.226-14.477l129.551 129.645 12.281-.117zM162.921 350.353a45.846 45.846 0 01-25.48-7.733 45.902 45.902 0 01-6.95-70.603 45.84 45.84 0 0149.981-9.947 45.863 45.863 0 0120.583 16.901 45.9 45.9 0 017.729 25.494 45.951 45.951 0 01-13.448 32.432 45.904 45.904 0 01-32.415 13.456z",
    fill: "#F34C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.853 474.076L205.962 338.118a54.775 54.775 0 00-7.511-75.498 54.708 54.708 0 00-75.698 4.489 54.77 54.77 0 00-14.533 38.221 54.768 54.768 0 0015.987 37.636 54.71 54.71 0 0037.588 16.059 54.708 54.708 0 0038.226-14.477l129.551 129.645 12.281-.117zM162.921 350.353a45.846 45.846 0 01-25.48-7.733 45.902 45.902 0 01-6.95-70.603 45.84 45.84 0 0149.981-9.947 45.863 45.863 0 0120.583 16.901 45.9 45.9 0 017.729 25.494 45.951 45.951 0 01-13.448 32.432 45.904 45.904 0 01-32.415 13.456v0z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.136 474.082l-32.016.111-76.157-77.367 15.482-15.491 92.691 92.747z",
    fill: "#6EC6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.136 474.082l-32.016.111-76.157-77.367 15.482-15.491 92.691 92.747z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.072 243.366h116.849a11.686 11.686 0 0111.685 11.691v219.505H576.387V255.057a11.686 11.686 0 0111.685-11.691z",
    fill: "#fff",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.844 263.826v204.89H585.152v-204.89c0-3.101 1.231-6.075 3.422-8.267a11.68 11.68 0 018.263-3.424h99.322a11.69 11.69 0 0111.685 11.691z",
    fill: "#F2F2F2",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.282 449.717c8.067 0 14.606-6.542 14.606-14.614 0-8.071-6.539-14.614-14.606-14.614s-14.606 6.543-14.606 14.614c0 8.072 6.539 14.614 14.606 14.614z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 291.3h-17.528a5.845 5.845 0 00-5.842 5.846v17.537a5.845 5.845 0 005.842 5.846h17.528a5.845 5.845 0 005.842-5.846v-17.537a5.845 5.845 0 00-5.842-5.846z",
    fill: "#F34C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.754 291.3h-17.528a5.845 5.845 0 00-5.842 5.846v17.537a5.845 5.845 0 005.842 5.846h17.528a5.845 5.845 0 005.842-5.846v-17.537a5.845 5.845 0 00-5.842-5.846zM681.99 425.926v18.355M691.169 435.103h-18.352",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.193 291.3h-53.751a2.338 2.338 0 000 4.677h53.751a2.338 2.338 0 000-4.677z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.193 291.3h-53.751a2.338 2.338 0 000 4.677h53.751a2.338 2.338 0 000-4.677z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.485 302.699h-53.751a2.338 2.338 0 000 4.677h53.751a2.338 2.338 0 000-4.677z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.485 302.699h-53.751a2.338 2.338 0 000 4.677h53.751a2.338 2.338 0 000-4.677z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.485 362.91h-53.751a2.338 2.338 0 000 4.676h53.751a2.337 2.337 0 000-4.676z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.485 362.91h-53.751a2.338 2.338 0 000 4.676h53.751a2.337 2.337 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.586 395.645h-85.885a2.338 2.338 0 000 4.677h85.885a2.338 2.338 0 000-4.677z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.586 395.645h-85.885a2.338 2.338 0 000 4.677h85.885a2.338 2.338 0 000-4.677z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.551 341.281h-95.817a2.338 2.338 0 000 4.676h95.817a2.337 2.337 0 000-4.676z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.551 341.281h-95.817a2.338 2.338 0 000 4.676h95.817a2.337 2.337 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.551 351.803h-95.817a2.338 2.338 0 000 4.676h95.817a2.337 2.337 0 000-4.676z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.551 351.803h-95.817a2.338 2.338 0 000 4.676h95.817a2.337 2.337 0 000-4.676z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.158 252.135h-99.323a11.678 11.678 0 00-8.262 3.424 11.695 11.695 0 00-3.423 8.267v9.645h122.692v-9.645c0-3.101-1.231-6.075-3.422-8.267a11.678 11.678 0 00-8.262-3.424z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.962 99.446c4.459 0 8.074-2.34 8.074-5.226s-3.615-5.226-8.074-5.226-8.074 2.34-8.074 5.226 3.615 5.226 8.074 5.226z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.823 465.793H36.834a2.922 2.922 0 00-2.92 2.923v2.923a2.922 2.922 0 002.92 2.923h685.989a2.922 2.922 0 002.921-2.923v-2.923a2.922 2.922 0 00-2.921-2.923z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeWidth: 1.49,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.921 151.589a18.275 18.275 0 01-12.939-5.364 18.31 18.31 0 01-5.354-12.95c0-5.986 3.71-12.013 7.735-15a6.069 6.069 0 002.443-4.881v-5.553h16.224v5.559a6.088 6.088 0 002.442 4.881c4.032 2.987 7.742 9.014 7.742 15a18.325 18.325 0 01-5.356 12.946 18.283 18.283 0 01-12.937 5.362z",
    fill: "#F2F2F2",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.036 98.593h-16.148v9.259h16.148v-9.26z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.036 94.22h-16.148v4.373h16.148V94.22z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.276 132.474a4.803 4.803 0 11-9.605 0c0-2.087 1.595-4.53 2.991-4.53 1.397 0 3.19 2.443 3.19 4.53a4.796 4.796 0 01-5.118 4.794 4.916 4.916 0 01-4.487-4.958v-3.63c0-4.676 9.933-7.202 9.933-13.263v-7.565",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.706 132.474a4.805 4.805 0 01-8.199 3.398 4.805 4.805 0 01-1.407-3.398c0-2.087 1.601-4.53 2.992-4.53 1.39 0 3.196 2.443 3.196 4.53a4.805 4.805 0 01-8.199 3.398 4.808 4.808 0 01-1.406-3.398",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.129 132.474a4.802 4.802 0 11-9.605 0c0-2.087 1.595-4.53 2.992-4.53 1.396 0 3.19 2.443 3.19 4.53a4.805 4.805 0 01-8.199 3.398 4.808 4.808 0 01-1.406-3.398",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.559 132.474a4.797 4.797 0 01-1.407 3.398 4.804 4.804 0 01-8.198-3.398c0-2.087 1.595-4.53 2.991-4.53 1.397 0 3.196 2.443 3.196 4.53a4.803 4.803 0 11-9.605 0M174.559 132.31v-3.63c0-4.676-9.932-7.202-9.932-13.263v-7.565M162.955 88.994a13.499 13.499 0 00-3.947-9.544 13.484 13.484 0 00-9.537-3.953H90.813c-3.578 0-7.01 1.422-9.54 3.953a13.501 13.501 0 00-3.95 9.544v90.567M162.962 171.02v-12.696M189.323 107.338l-8.974 8.979M145.569 151.116l-8.974 8.979M200.248 133.713h-12.695M138.37 133.713h-12.695M180.349 151.116l8.974 8.979M136.595 107.338l8.974 8.979",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.956 258.577c-1.391 0-2.77.07-4.137.192a45.841 45.841 0 0129.738 14.739 45.89 45.89 0 010 61.908 45.84 45.84 0 01-29.738 14.738c1.367.123 2.746.199 4.137.199a45.848 45.848 0 0032.43-13.44 45.902 45.902 0 000-64.896 45.848 45.848 0 00-32.43-13.44z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty_1_svg__clip0_10367_212356"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h774v475H0z"
  })))));
}

export default SvgEmpty1;